const BASE = process.env.REACT_APP_API_URL || '/api';

export const api = {
  _headers() {
    const token = localStorage.getItem('token');
    return { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) };
  },
  async _handleError(r) {
    let msg = `Error ${r.status}`;
    let cuerpo = {};
    try { cuerpo = await r.json(); msg = cuerpo.error || cuerpo.message || msg; } catch {}
    // 413 del servidor web (no trae JSON): el envío completo pesa demasiado
    if (r.status === 413 && !cuerpo.error) msg = 'Los archivos pesan demasiado: el máximo es 40 MB por archivo. Comprímelos e inténtalo de nuevo.';
    // El mensaje sigue siendo `e.message` (nadie tiene que cambiar), pero el cuerpo
    // y el código quedan disponibles: hay errores que traen datos para decidir qué
    // ofrecerle al usuario, como si un renombre bloqueado se puede forzar.
    const err = new Error(msg);
    err.status = r.status;
    err.datos = cuerpo;
    throw err;
  },
  async get(path) {
    const r = await fetch(`${BASE}${path}`, { headers: this._headers() });
    if (!r.ok) await this._handleError(r);
    return r.json();
  },
  async post(path, body) {
    const r = await fetch(`${BASE}${path}`, { method: 'POST', headers: this._headers(), body: JSON.stringify(body) });
    if (!r.ok) await this._handleError(r);
    return r.json();
  },
  async put(path, body) {
    const r = await fetch(`${BASE}${path}`, { method: 'PUT', headers: this._headers(), body: JSON.stringify(body) });
    if (!r.ok) await this._handleError(r);
    return r.json();
  },
  async patch(path, body) {
    const r = await fetch(`${BASE}${path}`, { method: 'PATCH', headers: this._headers(), body: JSON.stringify(body) });
    if (!r.ok) await this._handleError(r);
    return r.json();
  },
  async del(path, body) {
    const opts = { method: 'DELETE', headers: this._headers() };
    if (body !== undefined) opts.body = JSON.stringify(body);
    const r = await fetch(`${BASE}${path}`, opts);
    if (!r.ok) await this._handleError(r);
    return r.json();
  },
  async downloadPdf(path) {
    const r = await fetch(`${BASE}${path}`, { headers: this._headers() });
    if (!r.ok) throw new Error('Error al generar PDF');
    return r.blob();
  },
  async postBlob(path, body) {
    const r = await fetch(`${BASE}${path}`, { method: 'POST', headers: this._headers(), body: JSON.stringify(body) });
    if (!r.ok) throw new Error('Error al generar PDF');
    return r.blob();
  },
  async upload(path, formData) {
    const token = localStorage.getItem('token');
    const r = await fetch(`${BASE}${path}`, {
      method: 'POST',
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      body: formData,
    });
    if (!r.ok) await this._handleError(r);
    return r.json();
  },
  downloadFile(path) {
    const token = localStorage.getItem('token');
    return fetch(`${BASE}${path}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    });
  },
};
